import React, { useState } from 'react'
import { Header } from './header'
import { Footer } from './footer'
import { ContactSEO } from './SEO'
import { toast } from 'react-toastify'
import { addcontact } from '../services/homeser'

export const Contact = () => {
    const [Name, setName] = useState('');
    const [Mail, setMail] = useState('');
    // const [Phone, setPhone] = useState('');
    const [Sub, setSub] = useState("");
    const [Msg, setMsg] = useState("");
    const [Error, setError] = useState({});
    
    const handlecontact = (e) => {
        e.preventDefault();
        let valid = true;
        const newErrors = { Name: "", Mail: "",Sub: "", Msg: "",};

        if (!Name) { newErrors.Name = "Name is required"; valid = false; }
        if (!Mail) { newErrors.Mail = "EMail is required"; valid = false; }
        if (!Sub) { newErrors.Sub = "Subject is required"; valid = false; }
        if (!Msg) { newErrors.Msg = "Message is required"; valid = false; }

        setError(newErrors);
        if (!valid) return;

        let data = new FormData();
        data.append("name", Name);
        data.append("email", Mail);
        data.append("subject", Sub);
        data.append("message", Msg);

        addcontact(data).then((res) => {
            if (res && res.status) {
                toast.success("Message sent successfully");
                setName(''); setMail(''); setSub(''); setMsg(''); setError({});
            } else {
                toast.error(res.message || "Failed to send message");
            }
        }).catch((err) => {
            toast.error("Something went wrong");
        });
    }
    return (
        <>
            <ContactSEO />
            <Header />
            <section className="inner-section single-banner" style={{ background: "url(" + require("../assets/images/slider/single-banner.jpg") + ") no-repeat center" }}>
                <div className="container">
                    <h2>Contact Us</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Contact</li>
                    </ol>
                </div>
            </section>
            <section className="inner-section contact-part">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-lg-4">
                            <div className="contact-card">
                                <i className="icofont-location-pin"></i>
                                <h4>Show Room</h4>
                                <p>75, Thammampatti Main Road, Vazhapadi, Salem District, Tamil Nadu 636115</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="contact-card active">
                                <i className="icofont-phone"></i>
                                <h4>phone number</h4>
                                <p>
                                    <a href="tel:+9865230900">+91 9865230900</a>
                                    <a href="tel:+8838569796">+91 8838569796</a>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="contact-card">
                                <i className="icofont-email"></i>
                                <h4>Support mail</h4>
                                <p>
                                    <a href="mailto:asm.manivannan@gmail.com">asm.manivannan@gmail.com</a>
                                    <a href="mailto:info@asmweddingcards.com">info@asmweddingcards.com</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="contact-map">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3907.58988191401!2d78.4016343!3d11.6525456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bab8e1cfad60e0f%3A0x8f58578f3c92bf4!2sASM%20Graphics%20%26%20Printers%20%2C%20ASM%20Wedding%20Card!5e0!3m2!1sen!2sin!4v1775541155313!5m2!1sen!2sin" aria-hidden="false" tabindex="0"></iframe>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <form className="contact-form">
                                <h4>Drop Your Thoughts</h4>
                                <div className="form-group">
                                    <div className="form-input-group">
                                        <input className="form-control" type="text" placeholder="Your Name" value={Name} onChange={(e) => setName(e.target.value)} />
                                        <i className="icofont-user-alt-3"></i>
                                    </div>
                                    <span className="text-danger">{Error.Name}</span>
                                </div>
                                <div className="form-group">
                                    <div className="form-input-group">
                                        <input className="form-control" type="text" placeholder="Your Email" value={Mail} onChange={(e) => setMail(e.target.value)} />
                                        <i className="icofont-email"></i>
                                    </div>
                                    <span className="text-danger">{Error.Mail}</span>
                                </div>
                                <div className="form-group">
                                    <div className="form-input-group">
                                        <input className="form-control" type="text" placeholder="Your Subject" value={Sub} onChange={(e) => setSub(e.target.value)} />
                                        <i className="icofont-book-mark"></i>
                                    </div>
                                    <span className="text-danger">{Error.Sub}</span>
                                </div>
                                <div className="form-group">
                                    <div className="form-input-group">
                                        <textarea className="form-control" placeholder="Your Message" value={Msg} onChange={(e) => setMsg(e.target.value)}></textarea>
                                        <i className="icofont-paragraph"></i>
                                    </div>
                                    <span className="text-danger">{Error.Msg}</span>
                                </div>
                                <a type="submit" className="form-btn-group" onClick={(e) => handlecontact(e)}>
                                    <i className="fas fa-envelope"></i>
                                    <span>send message</span>
                                </a>
                            </form>
                        </div>
                    </div>
                </div>
            </section>


            <Footer />
        </>
    )
}
